export default {
  route: {
    template: 'Lascia un feedback - {n}',
    fallback: 'Lascia un feedback',
    //dynamic use
    aboutVisit: 'Informazioni sulla visita',
    checkout: 'Checkout',
    digitalReceipt: 'Ricevuta digitale',
    findVenue: 'Trova sede',
    getStarted: 'Inizia',
    guestReceiptPinEntry: 'Ricevuta ospite Inserimento Pin',
    guestTableNumberEntry: 'Inserimento numero tavolo',
    index: '',
    listNearbyLocations: 'Elenco località vicine',
    locationCheckIn: 'Check-in posizione',
    manageTeam: 'Gestisci squadra',
    questions: 'Domande',
    register: 'Registra dispositivo',
    recommend: 'Consiglia',
    share: 'Condividi',
    staff: 'Membro della Squadra',
    survey: 'Sondaggio ospite',
    thankYou: 'Not Implemented.',
    // TODO: Translate (PWA)
    tabletCheckIn: 'Check-in tablet',
    teamMemberReceiptPinEntry: 'Ricevuta membro del team Inserimento PIN',
    teamMemberTableNumberEntry: 'Inserimento del numero del tavolo dei membri del team',
    upload: 'Caricare',
    error404: '404'
  }
};